import Vue from 'vue'
import Announcements from './Announcements'

Vue.config.productionTip = false

function mount(component, element) {
  let itemSlug = element.dataset.slug
  if (element && itemSlug) {
    let $vm = new Vue(Announcements)
    $vm.itemSlug = itemSlug
    $vm.$mount(element)
  }
}

function mountNotices() {
  document
    .querySelectorAll('[data-mount=stm-item-announcements-notice]')
    .forEach(el => mount(Announcements, el))
}

// protection against multiple injection
if (!window.stmItemAnnouncementMounted) {
  mountNotices()
}

window.stmItemAnnouncementMounted = true
